"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_react_1 = require("lucide-react");
const SpellCheckIndicator = ({ status, size = 'sm', showCount = false, className = '' }) => {
    if (!status)
        return null;
    const sizeClasses = {
        sm: 'w-3 h-3',
        md: 'w-4 h-4',
        lg: 'w-5 h-5'
    };
    const iconSize = sizeClasses[size];
    // Checking state
    if (status.isChecking) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: `flex items-center space-x-1 ${className}`, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Clock, { className: `${iconSize} text-blue-500 animate-spin` }), showCount && ((0, jsx_runtime_1.jsx)("span", { className: "text-xs text-blue-600", children: "Kontroluji..." }))] }));
    }
    // Has errors
    if (status.hasErrors && status.errorCount > 0) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: `flex items-center space-x-1 ${className}`, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertCircle, { className: `${iconSize} text-red-500` }), showCount && ((0, jsx_runtime_1.jsx)("span", { className: "text-xs text-red-600 font-medium", children: status.errorCount }))] }));
    }
    // No errors
    return ((0, jsx_runtime_1.jsxs)("div", { className: `flex items-center space-x-1 ${className}`, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.CheckCircle, { className: `${iconSize} text-green-500` }), showCount && ((0, jsx_runtime_1.jsx)("span", { className: "text-xs text-green-600", children: "OK" }))] }));
};
exports.default = SpellCheckIndicator;
